import { render, staticRenderFns } from "./dataTableCtrl.vue?vue&type=template&id=839890aa&scoped=true&"
import script from "./dataTableCtrl.vue?vue&type=script&lang=js&"
export * from "./dataTableCtrl.vue?vue&type=script&lang=js&"
import style0 from "./dataTableCtrl.vue?vue&type=style&index=0&id=839890aa&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839890aa",
  null
  
)

export default component.exports